(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cicinia-suit-complete-look"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cicinia-suit-look')) {
  customElements.define('cicinia-suit-look', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.track = this.querySelector('.cicinia-suit-look__products');
      this.controls = this.querySelector('.cicinia-suit-look__controls');
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-look-direction]');
        if (!button) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({left:Number(button.dataset.lookDirection) * (this.track.firstElementChild.getBoundingClientRect().width + gap), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }, options);
      this.track.addEventListener('scroll', () => this.updateControls(), options);
      this.observer = new ResizeObserver(() => this.updateControls());
      this.observer.observe(this.track);
      this.updateControls();
    }
    disconnectedCallback() {this.controller?.abort();this.observer?.disconnect();}
    updateControls() {
      const end = this.track.scrollWidth - this.track.clientWidth;
      this.controls.hidden = end <= 1;
      this.controls.querySelector('[data-look-direction="-1"]').disabled = this.track.scrollLeft <= 1;
      this.controls.querySelector('[data-look-direction="1"]').disabled = this.track.scrollLeft >= end - 1;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cicinia-suit-custom-size"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cicinia-suit-custom-size')) {
  customElements.define('cicinia-suit-custom-size', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.container = this.closest('.product-form');
      this.productForm = document.getElementById(this.dataset.formId);
      this.panel = this.querySelector('.suit-custom__panel');
      this.measureForm = this.querySelector('[data-custom-form]');
      this.fields = [...this.querySelectorAll('[data-custom-field]')];
      this.properties = this.querySelector('[data-custom-properties]');
      this.messages = JSON.parse(this.querySelector('[data-custom-messages]').textContent);
      this.unit = 'in';
      this.saved = false;
      this.active = false;
      if (!this.container || !this.productForm) return;
      this.container.addEventListener('change', event => {
        if (event.target.matches('.cicinia-suit-sizes input')) this.sync();
      }, options);
      this.productForm.addEventListener('variant:changed', () => this.sync(), options);
      this.productForm.addEventListener('submit', event => {
        if (!this.isCustom()) return;
        this.sync();
        if (!this.measureForm.reportValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const invalid = this.fields.find(input => !input.validity.valid);
          invalid?.focus({preventScroll:true});
          invalid?.scrollIntoView({block:'center',behavior:'auto'});
          return;
        }
        this.save();
      }, {...options,capture:true});
      this.measureForm.addEventListener('submit', event => {
        event.preventDefault();
        this.updateMeasurements();
      }, options);
      this.measureForm.addEventListener('input', () => this.updateMeasurements(), options);
      this.querySelector('[data-custom-unit]').addEventListener('change', event => this.changeUnit(event.target.value), options);
      this.sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.container?.removeAttribute('data-suit-custom-active');
    }
    isCustom() {
      return this.container.querySelector('.cicinia-suit-sizes input:checked')?.value === 'Custom Size';
    }
    sync() {
      this.active = this.isCustom();
      this.panel.hidden = !this.active;
      this.container.toggleAttribute('data-suit-custom-active', this.active);
      this.properties.querySelectorAll('input').forEach(input => {input.disabled = !this.active || !this.saved;});
      this.querySelector('[data-custom-status]').textContent = this.messages[this.saved ? 'saved' : 'pending'];
    }
    updateMeasurements() {
      this.saved = this.fields.every(input => input.validity.valid);
      if (this.saved) this.save();
      else this.sync();
    }
    changeUnit(next) {
      if (next === this.unit) return;
      this.fields.forEach(input => {
        const ratio = input.dataset.customField === 'weight' ? 0.45359237 : 2.54;
        if (input.value && Number.isFinite(input.valueAsNumber)) input.value = (input.valueAsNumber * (next === 'cm' ? ratio : 1 / ratio)).toFixed(1);
      });
      this.unit = next;
      this.querySelectorAll('[data-field-unit]').forEach(label => {label.textContent = `(${label.dataset.fieldUnit === 'weight' ? (next === 'cm' ? 'kg' : 'lb') : next})`;});
      this.updateMeasurements();
    }
    save() {
      const values = this.fields.map(input => [input.dataset.propertyLabel, `${input.value} ${input.dataset.customField === 'weight' ? (this.unit === 'cm' ? 'kg' : 'lb') : this.unit}`]);
      const notes = this.querySelector('[data-custom-notes]').value.trim();
      if (notes) values.push(['Custom size notes', notes]);
      this.properties.replaceChildren(...values.map(([key,value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${key}]`;
        input.value = value;
        input.setAttribute('form', this.dataset.formId);
        return input;
      }));
      this.saved = true;
      this.sync();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cicinia-suit-fit-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cicinia-suit-fit-guide')) {
  customElements.define('cicinia-suit-fit-guide', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.config = JSON.parse(this.querySelector('[data-fit-config]').textContent);
      this.rows = this.config.rows.trim().split(/\r?\n/).map(row => row.split('|').map(cell => cell.trim()));
      this.form = document.getElementById(this.dataset.formId);
      this.container = this.form?.closest('.product-form');
      if (!this.container) return;
      this.picker = this.container.querySelector('product-variants');
      this.panelClick = event => {
        const unit = event.target.closest('[data-unit]');
        if (unit) this.setUnit(unit.dataset.unit);
        if (event.target.closest('[data-select-fit]')) this.selectFit();
      };
      this.panelChange = event => {if(event.target.matches('[data-fit-height],[data-fit-weight]')) this.findFit();};
      this.panels = Array.from(this.querySelectorAll('[data-suit-panel]')).map(source => {
        const panel = document.createElement('div');
        panel.dataset.suitPanel = source.dataset.suitPanel;
        panel.className = 'cicinia-suit-guide__details cicinia-suit-native-panel';
        Array.from(source.childNodes).forEach(node => {if (node.nodeName !== 'SUMMARY') panel.append(node);});
        source.remove();
        return panel;
      });
      this.mobileQuery = window.matchMedia('(max-width: 740px)');
      this.mobileQuery.addEventListener('change', () => this.mountPanels(), {signal:this.abort.signal});
      this.mountPanels();
      document.addEventListener('DOMContentLoaded', () => this.mountPanels(), {once:true,signal:this.abort.signal});
      document.addEventListener('shopify:section:load', () => this.mountPanels(), {signal:this.abort.signal});
      this.form?.addEventListener('variant:changed', () => queueMicrotask(() => {this.normalizeSize();this.highlight();}), {signal:this.abort.signal});
      this.form?.addEventListener('submit', event => {
        if(this.isExcluded()) {event.preventDefault();event.stopImmediatePropagation();this.normalizeSize();}
      }, {capture:true,signal:this.abort.signal});
      let attempts=0;
      const ready=()=>{if(!this.isConnected)return;if(this.picker?.product){this.normalizeSize();this.highlight();}else if(attempts++<100){this.timer=setTimeout(ready,100);}};
      ready();
      const product = this.container.closest('.cicinia-suit-product');
      const slot = product?.querySelector('.cicinia-suit-wishlist');
      if (slot) {
        const positionWishlist = () => {
          const button = product.querySelector('.product__info .wishlist-btn');
          const app = button?.closest('.shopify-app-block');
          if (app) slot.append(app);
        };
        this.wishlistObserver = new MutationObserver(positionWishlist);
        this.wishlistObserver.observe(product, {childList:true, subtree:true});
        positionWishlist();
      }
    }
    mountPanels() {
      const root = document.querySelector(`[data-suit-tabs-product="${this.dataset.productId}"]`);
      if (!root) {this.contentRoot = this;return;}
      const mobileHost = this.container?.querySelector('[data-suit-mobile-tabs]');
      const useMobile = this.mobileQuery?.matches && mobileHost;
      if (mobileHost) {
        root.closest('.shopify-section')?.toggleAttribute('data-suit-mobile-active', !!useMobile);
        if (useMobile) {
          const slots = Array.from(root.querySelectorAll('[data-suit-tab-slot]'));
          mobileHost.querySelectorAll('[data-suit-mobile-panel]').forEach(details => {
            if (!slots.some(slot => slot.dataset.suitTabSlot === details.dataset.suitMobilePanel)) details.remove();
          });
          slots.forEach(slot => {
            const key = slot.dataset.suitTabSlot;
            const toggle = slot.closest('.product-tabs__tab-item-wrapper')?.querySelector('.collapsible-toggle');
            if (!toggle) return;
            let details = mobileHost.querySelector(`[data-suit-mobile-panel="${key}"]`);
            if (!details) {
              details = document.createElement('details');
              details.dataset.suitMobilePanel = key;
              details.className = 'cicinia-suit-guide__details';
              details.append(document.createElement('summary'), document.createElement('div'));
              details.lastElementChild.dataset.suitTabSlot = key;
            }
            mobileHost.append(details);
            const summary = details.firstElementChild;
            summary.textContent = toggle.textContent.trim();
            const icon = toggle.querySelector('svg');
            if (icon) summary.append(icon.cloneNode(true));
          });
        }
      }
      const targetRoot = useMobile ? mobileHost : root;
      if (this.contentRoot !== targetRoot) {
        this.contentRoot?.removeEventListener('click', this.panelClick);
        this.contentRoot?.removeEventListener('change', this.panelChange);
        this.contentRoot = targetRoot;
        targetRoot.addEventListener('click', this.panelClick, {signal:this.abort.signal});
        targetRoot.addEventListener('change', this.panelChange, {signal:this.abort.signal});
      }
      const styles = getComputedStyle(this);
      ['--suit-accent','--suit-surface'].forEach(name => targetRoot.style.setProperty(name, styles.getPropertyValue(name)));
      this.panels.forEach(panel => {
        const slot = targetRoot.querySelector(`[data-suit-tab-slot="${panel.dataset.suitPanel}"]`);
        if (!slot) return;
        if (panel.parentElement !== slot) slot.replaceChildren(panel);
      });
      this.highlight();
    }
    disconnectedCallback(){this.abort?.abort();clearTimeout(this.timer);this.wishlistObserver?.disconnect();}
    sizeSelector(){return this.container.querySelector('.cicinia-suit-sizes');}
    isExcluded(){return this.dataset.filterSizes==='true' && !!this.sizeSelector()?.querySelector('[data-suit-excluded] input:checked');}
    normalizeSize(){
      if(!this.picker?.product || !this.isExcluded())return;
      const current=this.picker.selectedVariant;
      const index=this.picker.optionSelectors.indexOf(this.sizeSelector());
      const variants=this.picker.product.variants;
      const sameColor=variants.filter(v=>v.options[index]!=='XXS' && v.options.every((value,i)=>i===index || value===current.options[i]));
      const next=sameColor.find(v=>v.available) || sameColor[0];
      if(next)this.picker.selectVariant(next.id);
    }
    highlight(){
      const input=this.sizeSelector()?.querySelector('input:checked');
      const size=this.dataset.kind==='pants' ? input?.value.split('×')[0].trim() : input?.value;
      this.contentRoot.querySelectorAll('[data-fit-size],[data-size-column]').forEach(cell=>cell.toggleAttribute('data-selected',(cell.dataset.fitSize||cell.dataset.sizeColumn)===size));
      if(input?.value==='2XL' && this.dataset.filterSizes==='true'){
        const label=document.getElementById(input.dataset.bindValue);if(label)label.textContent='2XL';
      }
    }
    setUnit(unit){
      this.contentRoot.querySelectorAll('[data-unit]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.unit===unit)));
      this.contentRoot.querySelectorAll('[data-label-imperial]').forEach(el=>el.textContent=unit==='metric'?el.dataset.labelMetric:el.dataset.labelImperial);
      this.contentRoot.querySelectorAll('[data-cm]').forEach(el=>{const cm=Number(el.dataset.cm);if(Number.isFinite(cm))el.textContent=unit==='metric'?`${cm} cm`:`${(cm/2.54).toFixed(1)}″`;});
    }
    findFit(){
      const height=this.contentRoot.querySelector('[data-fit-height]').value,weight=this.contentRoot.querySelector('[data-fit-weight]').value;
      this.fitSize=height!==''&&weight!==''?this.rows[Number(weight)]?.[Number(height)+1]:null;
      const valid=this.fitSize&&this.fitSize!=='-';
      this.contentRoot.querySelector('[data-fit-result]').textContent=height===''||weight===''?this.config.pick:valid?`${this.config.result} ${this.fitSize}`:this.config.none;
      this.contentRoot.querySelector('[data-select-fit]').hidden=!valid;
    }
    selectFit(){
      const input=Array.from(this.sizeSelector()?.querySelectorAll('input[type=radio]')||[]).find(el=>el.value===this.fitSize);
      if(!input || input.disabled || input.closest('.is-disabled,[hidden],[data-suit-excluded]')){this.contentRoot.querySelector('[data-fit-result]').textContent=this.config.unavailable;return;}
      input.click();
      this.highlight();
      this.contentRoot.querySelector('[data-fit-result]').textContent=`${this.config.result} ${this.fitSize} · ${this.config.selected}`;
      input.focus({preventScroll:true});
      this.sizeSelector().scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cicinia-suit-selected-size"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cicinia-suit-selected-size')) {
  customElements.define('cicinia-suit-selected-size', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.container = this.closest('.product-form');
      this.container?.addEventListener('change', () => this.updateSize(), options);
      document.getElementById(this.dataset.formId)?.addEventListener('variant:changed', () => this.updateSize(), options);
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-size-unit]');
        if (button) this.updateUnit(button.dataset.sizeUnit);
      }, options);
      this.dialog = this.querySelector('dialog');
      this.container?.addEventListener('click', event => {
        const trigger = event.target.closest('[data-suit-size-guide]');
        if (trigger) {
          this.trigger = trigger;
          this.updateSize();
          this.dialog.showModal();
        }
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target.closest('[data-close-size]')) this.dialog.close();
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      }, options);
      this.dialog.addEventListener('close', () => this.trigger?.focus(), options);
      this.updateSize();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    updateSize() {
      const input = this.container?.querySelector('.cicinia-suit-sizes input:checked');
      if (!input) return;
      const size = this.dataset?.kind === 'pants' ? input.value.split('×')[0].trim() : input.value;
      this.querySelectorAll('[data-dialog-size]').forEach(cell => cell.toggleAttribute('data-current-size', cell.dataset.dialogSize === size));
    }

    updateUnit(unit) {
      this.querySelectorAll('[data-size-unit]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.sizeUnit === unit));
      });
      this.querySelectorAll('[data-size-cm]').forEach(cell => {
        const cm = Number(cell.dataset.sizeCm);
        cell.textContent = Number.isFinite(cm) ? (unit === 'cm' ? `${cm} cm` : `${(cm / 2.54).toFixed(1)}″`) : '—';
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
